import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 179-skip-to-mext
 * @see {GlyphIcon}
 */
const SkipToNextIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M20.44781,15.32617a.8.8,0,0,1,0,1.34766L10.23187,23.212a.8.8,0,0,1-1.2312-.67383V9.46185a.8.8,0,0,1,1.2312-.67383ZM23,8H22a1,1,0,0,0-1,1V23a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V9A1,1,0,0,0,23,8Z";
	}
}

export default SkipToNextIcon;